import { render } from "./clientdataset-status-list.vue?vue&type=template&id=3ceb3180"
import script from "./clientdataset-status-list.vue?vue&type=script&lang=js"
export * from "./clientdataset-status-list.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__